// @flow
import { gql, useQuery } from '@apollo/client';

type Props = {
  page?: number,
  limit?: number
}

type UsePaginatedDeploymentHistory = (props: ?Props) => {
  isFetching: boolean,
  deploymentHistory: Object[],
  refetchPaginatedDeploymentHistory: () => void
}

const usePaginatedDeploymentHistory: UsePaginatedDeploymentHistory = (props: ?Props) => {
  const { page = 1, limit = 10 } = props || {};
  const { data, previousData, loading, refetch } = useQuery(QUERY, {
    variables: {
      offset: (page - 1) * limit,
      limit
    },
    notifyOnNetworkStatusChange: true
  });

  return {
    isFetching: loading,
    // While more are loading, keep showing what's there.
    deploymentHistory: (data || previousData)?.deploymentHistory,
    refetchPaginatedDeploymentHistory: refetch
  };
}

const QUERY = gql`
query getPaginatedDeploymentHistory($offset: Int, $limit: Int) {
  deploymentHistory(offset: $offset, limit: $limit) {
    _id
    version
    gitCommitSHA
    isRollback
    timestamp
    deployedBy {
      username
    }
    data {
      pages {
        _id
        path
        version
        deploymentType
      }
    }
  }
}
`;

export default usePaginatedDeploymentHistory;
